import { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { getUserCountry } from 'data/actions/user';
import { userCountryCodeSelector } from 'data/selectors/user';

import { UAE_COUNTRY_CODE, USA_COUNTRY_CODE } from 'ts/constants/general';
import { LOCAL_STORAGE_KEYS } from 'ts/constants/local-storage-keys';

interface IGetUserCountry {
  userCountry: string;
  isUSA: boolean;
  isEurope: boolean;
  isUAE: boolean;
  setCountryInStorage: () => void;
}

export const europeanCountries = [
  'AT',
  'BE',
  'BG',
  'HR',
  'CZ',
  'CY',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',
  'GB',
  'UK',
  'UAE',
  'AE'
];

/**
 * @description
 */
export function useGetUserCountry(): IGetUserCountry {
  const dispatch = useDispatch();
  const [isUSA, setIsUSA] = useState(false);
  const [isEurope, setIsEurope] = useState(false);
  const [isUAE, setIsUAE] = useState(false);
  const [userCountry, setUserCountry] = useState('');
  const countryCode = useSelector(userCountryCodeSelector);

  const setCountryInStorage = () => {
    const userCountryFromStorage = localStorage.getItem(LOCAL_STORAGE_KEYS.USER_COUNTRY);
    if (userCountryFromStorage || countryCode) {
      return;
    }

    dispatch(
      getUserCountry((res: { country: string }) => {
        localStorage.setItem(LOCAL_STORAGE_KEYS.USER_COUNTRY, res.country);
      })
    );
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const queryUserCountry = searchParams.get(LOCAL_STORAGE_KEYS.USER_COUNTRY);

    const userCountryFromStorage = localStorage.getItem(LOCAL_STORAGE_KEYS.USER_COUNTRY);

    const userCountryCode = countryCode || userCountryFromStorage || queryUserCountry;
    if (userCountryCode) {
      setUserCountry(userCountryCode);
      setIsUSA(userCountryCode === USA_COUNTRY_CODE);
      setIsUAE(userCountryCode === UAE_COUNTRY_CODE);
      setIsEurope(europeanCountries.includes(userCountryCode));

      if (!userCountryFromStorage) {
        localStorage.setItem(LOCAL_STORAGE_KEYS.USER_COUNTRY, userCountryCode);
      }

      return;
    }

    dispatch(
      getUserCountry((res: { country: string }) => {
        localStorage.setItem(LOCAL_STORAGE_KEYS.USER_COUNTRY, res.country);
        setUserCountry(res.country);
        setIsUSA(res.country === USA_COUNTRY_CODE);
        setIsUAE(res.country === UAE_COUNTRY_CODE);
        setIsEurope(europeanCountries.includes(res.country));
      })
    );
  }, [countryCode, dispatch]);

  return { userCountry, isUSA, isEurope, isUAE, setCountryInStorage };
}
